

<div class="documentBox"> 


  <div Id="document" class="documents" [ngClass]="{ list: true, grid: false }">
    <mat-accordion  [multi]="true">

      <ng-container *ngFor="let folder of FormFolderReportList; let i = index">

        <mat-expansion-panel  [expanded]="step === i"  disabled="false" (click)="togglePanels(i)">
          <mat-expansion-panel-header>
            <mat-panel-title class="header">
              <div class="titleCount">
                <div class="folderName">
                  {{ folder.folderName }}
                  <span class="count">{{ folder.forms.length }}</span>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="documentcontainer">        
                    

            <div  class="categories">

              <ul>               

                <li *ngFor="let document of folder.forms;let j=index">  
                    <div class="documentList">
                      <span class="reportName" >
                        {{ document.formName }}  &nbsp; <mat-icon style="cursor: pointer;" (click)="openHtmlData(document)">info</mat-icon>
                      </span>

  <table class="table" style="overflow-y: scroll; max-height:600px;" *ngIf="!noRecordFound">
  <span *ngFor="let row of document.datatable; let i = index">
    <thead>
      <th class="col">{{ row.columnName }}</th>
    </thead>

    <tr *ngFor="let rowdata of row.value; let j = index">
      <td>
        <!-- If column is "Submited By", show Preview button -->
        <ng-container *ngIf="row.columnName === 'Submitted By'; else normalCell">
          <span class="submittedByCell">
          <mat-icon *ngIf="rowdata !== '-'"  color="primary"
            style="cursor: pointer;" matTooltip="Preview"
            (click)="viewHTMLData(rowdata, j,folder,document)">
            visibility
          </mat-icon>
            {{ rowdata }}         
          </span>
          <!-- <button *ngIf="rowdata !== '-'"
           mat-stroked-button color="primary"
            (click)="viewHTMLData(rowdata, j)">
            Preview
          </button> -->
        </ng-container>

        <!-- Normal cell display for other columns -->
        <ng-template #normalCell>
          <ng-container *ngIf="row.type == 'Signature'; else elseifInitials">
            <img *ngIf="rowdata.substring(0,5) == 'data:'" height="32px" src="{{ rowdata }}" />
            <p *ngIf="rowdata == '-'">-</p>
            <p *ngIf="rowdata.substring(0,5) != 'data:' && rowdata != '-'">{{ rowdata }}</p>
          </ng-container>

          <ng-template #elseifInitials>
            <ng-container *ngIf="row.type == 'Initials'; else elseifImage">
              <img *ngIf="rowdata.substring(0,5) == 'data:'" height="32px" src="{{ rowdata }}" />
              <p *ngIf="rowdata == '-'">-</p>
              <p *ngIf="rowdata.substring(0,5) != 'data:' && rowdata != '-'">{{ rowdata }}</p>
            </ng-container>
          </ng-template>

          <ng-template #elseifImage>
            <ng-container *ngIf="row.type == 'Image'; else elseifFile">
              <img *ngIf="rowdata.substring(0,5) == 'data:'" height="32px" src="{{ rowdata }}" />
              <p *ngIf="rowdata == '-'">-</p>
            </ng-container>
          </ng-template>

          <ng-template #elseifFile>
            <ng-container *ngIf="row.type == 'File'; else elseRow">
              <p *ngIf="rowdata.substring(0,5) == 'data:'" (click)="DownloadFile(rowdata, row)">Download</p>
              <p *ngIf="rowdata == '-'">-</p>
            </ng-container>
          </ng-template>

          <ng-template #elseRow><p>{{ rowdata }}</p></ng-template>
        </ng-template>
      </td>
    </tr>
  </span>
  </table>

                      <!-- <table class="table" style="overflow-y: scroll;max-height:600px;">
                        <span *ngFor="let row of document.datatable; let i = index">
                            <thead>
                                <th class="col">{{row.columnName}}</th>
                            </thead>
                  
                              <tr *ngFor="let rowdata of row.value;">
                                  
                              <td>
                                <ng-container *ngIf="row.type=='Signature'; else elseifInitials">
                                  <img *ngIf="rowdata.substring(0,5) == 'data:'" height="17px" src={{rowdata}}/>
                                    <p *ngIf="rowdata=='-'">-</p>
                                    <p *ngIf="rowdata.substring(0,5)!= 'data:' && rowdata!='-'">{{rowdata}}</p>          
                                </ng-container>
                    
                                <ng-template #elseifInitials>
                                <ng-container *ngIf="row.type=='Initials'; else elseifImage">
                                  <img *ngIf="rowdata.substring(0,5) == 'data:'" height="17px"   src={{rowdata}}/>
                                    <p *ngIf="rowdata=='-'">-</p>
                                    <p *ngIf="rowdata.substring(0,5)!= 'data:' && rowdata!='-'">{{rowdata}}</p>
                                </ng-container>
                                </ng-template>
                                
                    
                                <ng-template #elseifImage>
                                  <ng-container *ngIf="row.type=='Image'; else elseifFile">
                                    <img *ngIf="rowdata.substring(0,5) == 'data:'" height="17px"   src={{rowdata}}/>
                                    <p *ngIf="rowdata=='-'">-</p>
                                  </ng-container>
                                  </ng-template>
                    
                                  <ng-template #elseifFile>
                                    <ng-container *ngIf="row.type=='File'; else elseRow">
                                      <p *ngIf="rowdata.substring(0,5) == 'data:'" (click)="DownloadFile(rowdata,row)"> Download</p>
                                      <p *ngIf="rowdata=='-'">-</p>
                                    </ng-container>
                                    </ng-template>
                                                    
                                <ng-template #elseRow><p>{{rowdata}}</p></ng-template>   
                              </td> 
                                
                            </tr> 
                      
                          </span>
                      </table> -->
                    </div>
                </li>
              </ul>
            </div>
          </div>
        
        </mat-expansion-panel>

       
      </ng-container>

    </mat-accordion>
  </div>

</div>


<!-- <app-htmlReportData3c (getCloseHtmlData)="getCloseHtmlData($event)" [ngClass]="{ open: htmlData }" >
</app-htmlReportData3c> -->




